import WizardInstall from "../../../../contents/docs/getting-started/_snippets/wizard.mdx";
import * as React from 'react';
export default {
  WizardInstall,
  React
};